import { render } from "./modalComponent.vue?vue&type=template&id=e9f64b4a&scoped=true"
import script from "./modalComponent.vue?vue&type=script&lang=js"
export * from "./modalComponent.vue?vue&type=script&lang=js"

import "./modalComponent.vue?vue&type=style&index=0&id=e9f64b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9f64b4a"]])

export default __exports__